import { useState } from "react";
import { useParams } from "react-router-dom";
import ActividadesAplicacionListLayerPlantel from "../seleccion-aplicacion/actividades-aplicacion-plantel/ActividadesAplicacionListLayerPlantel";
import FrasesSeleccionAplicacionListLayerPlantel from "./frases-seleccion-aplicacion-plantel/FrasesSeleccionAplicacionListLayerPlantel";
import ConfiguracionAplicacionPlantelForm from "./aplicacion-config-plantel/ConfiguracionAplicacionPlantelForm";

// Tab "frases" (Frases de opción) queda oculta a pedido — el componente
// y su ruta siguen existiendo por si se necesita reactivar más adelante.
const tabs = [
  { key: "actividades", label: "Actividades" },
  // { key: "frases", label: "Frases" },
  { key: "configuracion", label: "Configuración" },
];

const PlantelApplicationTab = () => {
  const { plantelId } = useParams();
  const [activeTab, setActiveTab] = useState("actividades");

  return (
    <div className="card radius-8">
      {/* HEADER — solo navegación */}
      <div className="card-header border-bottom bg-base ps-0 py-0">
        <ul className="nav bordered-tab nav-pills mb-0 flex-wrap">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.key}>
              <button
                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* BODY — contenido */}
      <div className="card-body">
        {activeTab === "actividades" && (
          <ActividadesAplicacionListLayerPlantel key={plantelId} />
        )}
        {activeTab === "frases" && (
          <FrasesSeleccionAplicacionListLayerPlantel key={plantelId} />
        )}
        {activeTab === "configuracion" && (
          <ConfiguracionAplicacionPlantelForm key={plantelId} />
        )}
      </div>
    </div>
  );
};

export default PlantelApplicationTab;
